const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Quarter Three Icon</title><desc>A picture depicting a quarter of a circle next to a three-thirds circle.</desc><path d="M15.5 2a6.5 6.5 0 010 13h-.65V9.15H9V8.5A6.508 6.508 0 0115.5 2zm.65 11.66a5.2 5.2 0 10-5.81-5.81h5.81zM2 11a11 11 0 0011 11V11zm5 6H6v-4h1zm2 0H8v-4h1zm2 0h-1v-4h1z"/></svg>';
export {
  e as default
};
